/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from 'mobx-react'
import styles from './LoginModal.module.less'
import { Modal, Spin } from 'antd'
import { IconImage } from '../Icon/Icon'
import { useState, useEffect, useCallback } from 'react'
import { api } from '@/helpers/api'
import { userService } from '@/services/userService/userService'
import emitter, { EmitterEvents } from '@/helpers/emitter'

export interface LoginModalProps {
  visible: boolean
  onClose: () => void
}

let timer: NodeJS.Timeout | null = null

const LoginModal = observer(({ visible, onClose }: LoginModalProps) => {
  const [loading, setLoading] = useState(false)
  const [qrCode, setQrCode] = useState<ServerData.LoginQrCodeData>()

  const checkState = useCallback(async (sceneId: string) => {
    const { data } = await api.user.checkQrLogin(sceneId)
    console.log(data)
    if (data.register) {
      await userService.getUserInfo()
      emitter.emit(EmitterEvents.LOGIN_SUCCESS)
      onClose()
    } else {
      if (data.status === 'code_expired') {
        // getLoginQr()
      } else {
        timer = setTimeout(() => {
          checkState(sceneId)
        }, 1000)
      }
    }
  }, [])

  const stopCheck = useCallback(() => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }, [])

  const getLoginQr = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await api.user.getLoginQr()
      setQrCode(data)
      checkState(data.sceneId)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    stopCheck()
    if (visible) {
      getLoginQr()
    }
    return () => stopCheck()
  }, [getLoginQr, stopCheck, visible])

  return (
    <Modal
      open={visible}
      footer={null}
      closeIcon={false}
      onCancel={onClose}
      width={758}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.loginModal}>
        <div className={styles.modalClose} onClick={onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalContent}>
          <div className={styles.leftBox}>
            <IconImage width={116} src='IconCustomerLogo' />
            <p className={styles.title}>PPT从此会说话</p>
            <div className={styles.line}></div>
            <p className={styles.subtitle}>
              <IconImage src='IconCustomerCheck' width={16} /> 智能适配多场景
            </p>
            <p className={styles.subtitle}>
              <IconImage src='IconCustomerCheck' width={16} /> 海量风格随心切换
            </p>
            <p className={styles.subtitle}>
              <IconImage src='IconCustomerCheck' width={16} /> 直接插入PPT免调试
            </p>
          </div>
          <div className={styles.rightBox}>
            <div className={styles.rightBoxTitle}>登录</div>
            <div className={styles.rightBoxSubtitle}>
              <IconImage src='IconWexin' width={16} />
              请使用微信扫码
            </div>
            {loading ? (
              <Spin>
                <div className={styles.customerQr}></div>
              </Spin>
            ) : (
              <div className={styles.customerQr}>
                <img
                  className={styles.customerQrImg}
                  src={qrCode?.url}
                  alt='登陆二维码'
                  draggable={false}
                />
              </div>
            )}

            <div className={styles.customerQrText}>微信扫码即可登录</div>
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default LoginModal
